import { render, staticRenderFns } from "./ttshop_orderxq.vue?vue&type=template&id=026e850a&scoped=true&"
import script from "./ttshop_orderxq.vue?vue&type=script&lang=js&"
export * from "./ttshop_orderxq.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_orderxq.vue?vue&type=style&index=0&id=026e850a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026e850a",
  null
  
)

export default component.exports